/* eslint-disable */
import React, { memo, useEffect, useState } from "react";
import styles from "./PresenterCard.module.css";
import { pluralize } from "humanize-plus";
import {  useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { resetfilter } from "../../../../common/video/VideoFilterActions";
import { FilteredUserInfo } from "../../models/UserFilter";
import { isAdmin, UserData } from "../../../../user/User";
import { AppState } from "../../../../root/RootReducer";
import { verticalList } from "../../../../common/homePage/model/HomePage";
import { useSpring, animated as a } from "react-spring";
// import ProjectIcon from "@material-ui/icons/Work";
import VideoIcon from "@material-ui/icons/Theaters";
import PuiTypography from "../../../../components/elements/PuiTypography";
import classNames from "classnames";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
  addRecProfessional,
  removeRecProfessional,
} from "../../../../common/homePage/HomePageActions";
import NewIcon from "../../../../common/components/images/NewIcon";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import useResponsive from "../../../../common/useResponsive";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    addUserIcon: {
      position: "absolute",
      top: "5px",
      right: "5px",
      fontSize: "30px",
      cursor: "pointer",
      color: "var(--red)",
    },
    tag: {
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "7px",
      borderRadius: "2em",
      backgroundColor: "var(--red)",
      textTransform: "none",
    },
    tagMobile: {
      height: "30px",
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "7px",
      borderRadius: "15px",
      backgroundColor: "var(--red)",
      textTransform: "none",
      minWidth: "unset",
      width: "auto",
      padding: "4px 8px",
    },
  })
);

interface PresenterCardProps {
  userInfo?: UserData;
  filteredUserInfo?: FilteredUserInfo;
  recProList?: verticalList[];
  link?: string;
  openMsg?: (event: React.MouseEvent, flg: boolean, name: string) => void;
}

function PresenterCard({
  userInfo,
  filteredUserInfo,
  recProList,
  link,
  openMsg,
}: PresenterCardProps) {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { user, recommendProfessionalList } = useSelector((state: AppState) => ({
    user: state.user.userInfo,
    recommendProfessionalList: state.recommendList.recommendProfessionalList,
  }));

  const { isDesktop, isMobile } = useResponsive();

  const userName = userInfo ? userInfo.fullName : filteredUserInfo ? filteredUserInfo.name : "";
  const userId = userInfo
    ? parseInt(userInfo.id)
    : filteredUserInfo
    ? parseInt(filteredUserInfo.id)
    : -1;
  const imageUrl = userInfo ? userInfo.imageUrl : filteredUserInfo ? filteredUserInfo.imageUrl : "";
  const videoCount = userInfo ? 0 : filteredUserInfo ? filteredUserInfo.videoCount : 0;
  const skills = userInfo ? [] : filteredUserInfo ? filteredUserInfo.skills : [];
  const isVisibleNewIcon = filteredUserInfo ? filteredUserInfo.visibleNewIcon : false;
  const recPro = recProList?.filter((recPro) => parseInt(recPro.id) === userId);
  const [isAdded, setIsAdded] = React.useState(recPro ? recPro.length > 0 : false);

  // const clickInfoIcon = (id: number, name: string) => {
  //     const professionalFilter = {
  //         id: id === -1 ? [] : [id.toString()],
  //         professional: name === "" ? [] : [name],
  //         program:[], project:[], tag:[]
  //    };

  //     dispatch(resetfilter(professionalFilter));
  //     dispatch(changeMenu("/presenter", "/project", "right"));
  //};

  const clickProfile = (id: number, name: string) => {
    const professionalFilter = {
      id: id === -1 ? [] : [id.toString()],
      professional: name === "" ? [] : [name],
      program: [],
      project: [],
      tag: [],
    };

    dispatch(resetfilter(professionalFilter));
    navigate(link.startsWith("/") ? link : `/${link}`)
  };

  const [isLimitRecommendProfessionals, ChangeLimitRecommendProfessionals] = React.useState(false);
  const [recommendProfessionalNum, ChangeRecommendProfessionalNum] = React.useState(0);

  const addRecommendPro = (event: React.MouseEvent) => {
    if (recommendProfessionalNum < 3) {
      dispatch(addRecProfessional(userId));
      setIsAdded(!isAdded);
      if (openMsg) {
        openMsg(event, isAdded, userName);
      }
      event.nativeEvent.stopImmediatePropagation();
    } else {
      ChangeLimitRecommendProfessionals(true);
    }
  };

  const CloseLimitRecommendProfessionalBar = () => {
    ChangeLimitRecommendProfessionals(false);
  };

  const removeRecommendPro = (event: React.MouseEvent) => {
    dispatch(removeRecProfessional(userId));
    setIsAdded(!isAdded);

    if (openMsg) {
      openMsg(event, isAdded, userName);
    }

    event.nativeEvent.stopImmediatePropagation();
  };

  const [flipped, setFlipped] = useState(false);
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(1000px) rotateY(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 },
  });

  const handleMouseEnter = (event: React.MouseEvent) => {
    setFlipped(true);
  };

  const handleMouseLeave = (event: React.MouseEvent) => {
    setFlipped(false);
  };

  useEffect(() => {
    console.log("recommendProfessionalList更新", Object.keys(recommendProfessionalList).length);
    ChangeRecommendProfessionalNum(Object.keys(recommendProfessionalList).length);
  }, [recommendProfessionalList]);

  if (!link) {
    return (
      <div className={styles.profile}>
        <img className={styles.picture} src={imageUrl} alt="" />
        <div>
          <PuiTypography size={20} bold={true}>
            {userName}
          </PuiTypography>
        </div>
        <div>
          <PuiTypography size={16} color="gray-61">{`${videoCount}${pluralize(
            videoCount,
            "video"
          )}`}</PuiTypography>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <a.div
        className={styles.card}
        style={{
          opacity: opacity.interpolate((o) => 1 - Number(o)),
          transform,
          zIndex: flipped === false ? 50 : 10,
        }}
      >
        {isVisibleNewIcon && (
          <div className={styles.newIcon}>
            <NewIcon />
          </div>
        )}
        {!isAdded && isAdmin(user?.roles) && isDesktop && (
          <PersonAddIcon
            color="secondary"
            className={classes.addUserIcon}
            onClick={addRecommendPro}
          />
        )}
        {isAdded && isAdmin(user?.roles) && isDesktop && (
          <RemoveCircleOutlineIcon
            color="secondary"
            className={classes.addUserIcon}
            onClick={removeRecommendPro}
          />
        )}
        <div className={styles.link}>
          <div key={userName} className={styles.profile}>
            <img className={styles.picture} src={imageUrl} alt="" />
            <div>
              <PuiTypography size={isMobile ? 16 : 20} bold={true}>
                {userName}
              </PuiTypography>
            </div>
            <div>
              <PuiTypography size={isMobile ? 14 : 16} color="gray-61">{`${videoCount} ${pluralize(
                videoCount,
                "video"
              )}`}</PuiTypography>
            </div>

            <div className={styles.skillRow}>
              {skills.length > 0 &&
                skills.map((skill, index) => (
                  <Button
                    key={`${index}`}
                    size="small"
                    color="secondary"
                    variant="contained"
                    className={isMobile ? classes.tagMobile : classes.tag}
                  >
                    {skill}
                  </Button>
                ))}
            </div>
          </div>
        </div>
      </a.div>

      <a.div
        className={classNames(styles.card, styles.cardBack)}
        style={{
          opacity,
          transform: transform.interpolate((t) => `${t} rotateY(180deg)`),
          zIndex: flipped === true ? 50 : 10,
        }}
      >
        {isVisibleNewIcon && (
          <div className={styles.newIcon}>
            <NewIcon />
          </div>
        )}
        {!isAdded && isAdmin(user?.roles) && isDesktop && (
          <PersonAddIcon
            color="secondary"
            className={classes.addUserIcon}
            onClick={addRecommendPro}
          />
        )}
        {isAdded && isAdmin(user?.roles) && isDesktop &&  (
          <RemoveCircleOutlineIcon
            color="secondary"
            className={classes.addUserIcon}
            onClick={removeRecommendPro}
          />
        )}
        <div className={styles.link}>
          <div key={userName} className={styles.profile}>
            <img className={styles.picture} src={imageUrl} alt="" />
            <div>
              <PuiTypography size={isMobile ? 16 : 20} bold={true} color="white">
                {userName}
              </PuiTypography>
            </div>
            <div>
              <PuiTypography size={isMobile ? 14 : 16} color="gray-61">{`${videoCount} ${pluralize(
                videoCount,
                "video"
              )}`}</PuiTypography>
            </div>
            {/* <Link to={"project"} className={styles.backIconLink}>
                            <div className={styles.backIcon} onClick={() => clickInfoIcon(userId, userName)}>
                                <ProjectIcon color="secondary" style={{fontSize: 38, marginRight: "10px", color: "var(--red)"}}/>
                                <PuiTypography size={20} bold={true} color="white">Project</PuiTypography>
                            </div>
                            <ArrowForwardIosIcon style={{color: "white"}} onClick={() => clickInfoIcon(userId, userName)}/>
                        </Link> */}
            <div className={styles.backIconLink}  onClick={() => clickProfile(userId, userName)}>
              <div className={styles.backIcon}>
                <VideoIcon
                  color="secondary"
                  style={{
                    fontSize: isMobile ? 24 : 38,
                    marginRight: "10px",
                    color: "var(--red)",
                  }}
                />
                <PuiTypography size={isMobile ? 14 : 20} bold={true} color="white">
                  Video
                </PuiTypography>
              </div>
              <ArrowForwardIosIcon
                style={{ color: "white", fontSize: isMobile ? 16 : 30 }}
              />
            </div>
          </div>
        </div>
      </a.div>

      <PuiMessage
        open={isLimitRecommendProfessionals}
        duration={3000}
        type="error"
        title="おすすめPresenterはすでに3人登録されているので追加できません"
        onClose={CloseLimitRecommendProfessionalBar}
      />
    </div>
  );
}

export default memo(PresenterCard);
